import { EnqueteWelcome } from "../EnqueteCommon";

export function EnquetePreposeWelcome(props) {
  return <EnqueteWelcome {...props} pathPrefix="/mandataires/enquetes" />;
}
